import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class UpdateSigningStatusCommand extends BasicCommand<UpdateSigningStatusCommand> {
    readonly virkeskopskontraktSigneringId: number;

    static readonly $type = "UpdateSigningStatusCommand";

    static readonly $groupKey = "KontraktUtskrift";

    get primaryKey(): IPrimaryKey<UpdateSigningStatusCommand> {
        return {
            virkeskopskontraktSigneringId: this.virkeskopskontraktSigneringId
        };
    }

    constructor(virkeskopskontraktSigneringId: number) {
        super(UpdateSigningStatusCommand.$type, UpdateSigningStatusCommand.$groupKey, CommandType.Replace);
        this.virkeskopskontraktSigneringId = virkeskopskontraktSigneringId;
    }
}
